import { API, standardResponse, APICookie } from "./middleware";

export async function refreshToken(token) {
  const url = "/api/auth/refreshToken";
  const params = {
    refreshToken: token,
  };
  try {
    const response = await API.post(url, params);
    return response.data;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error.message);
    return {};
  }
}

export async function checkOTPRegister(phoneNumber, password1) {
  const url = "/api/auth/checkOTPRegister";
  const params = {
    tel: phoneNumber,
    password: password1,
  };

  return API.post(url, params)
    .then((response) => {
      standardResponse(true, response);
    })
    .catch((error) => standardResponse(false, error.response?.data));
}
export async function checkType2FALogin(username) {
  const url = "/api/auth/check2FAlogin";
  const params = {
    username,
  };
  let type2FA = 0;
  await API.post(url, params)
    .then((response) => {
      type2FA = response.data;
      return response;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return type2FA;
}

export async function loginToGetToken(username, password) {
  const url = "/api/auth/login";
  const params = {
    username,
    password,
  };
  let dataReceive = {};
  await API.post(url, params)
    .then((response) => {
      dataReceive = {
        token: response.data.token,
        userId: response.data?.userId,
        refreshToken: response.data.refreshToken,
        username: response.data.username,
        role: response.data.role,
        fullName: response.data.fullName,
        email: response.data.email,
        twofaType: response.data.twofaType,
        phone: response.data.phone,
      };
    })
    .catch((error) => console.error(error.message));
  return dataReceive;
}

export async function login(username, password) {
  const url = "/api/auth/login";
  const params = {
    username,
    password,
  };
  let dataReceive = {};
  await API.post(url, params)
    .then((response) => {
      dataReceive = {
        token: response.data.object?.token,
        refreshToken: response.data.object?.refreshToken,
        userId: response.data.object?.userId,
        username: response.data.object.username,
        fullName: response.data.object.fullName,
        email: response.data.object.email,
        phone: response.data.object.phone,
        permissions: response.data.object.permissions,
        permissionCodes: response.data.object.permissionCodes,
        partnerId: response.data.object.partnerId,
        roleId: response.data.object.roleId,
        roleName: response.data.object.roleName,
        departmentId: response.data.object.departmentId,
        imgLogo: response.data.object.imgLogo,
        twofaType: response.data.object.twofaType,
        groupCode: response.data.object.groupCode,
        colors: response.data.object.colors,
        status: response.data.status,
      };
    })
    .catch((error) => console.log(error.message));
  return dataReceive;
}

export async function sendOtp2FA(username) {
  const url = "/api/auth/sendOtp2FA";
  const params = username;
  let dataReceive = {};
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}

export async function checkOtp2FA(username, otp, email) {
  const url = "/api/auth/validateOtp";
  const params = { email, username, otp };
  let dataReceive = false;
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}

export async function sendSms2FA(username) {
  const url = "/api/auth/sendOtp2FA";
  const params = username;
  let dataReceive = {};
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
      // return response;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}

export async function validateSmsResetPassword(email, otp) {
  const url = "/api/auth/validateSmsResetPassword";
  const params = {
    email,
    otp,
  };
  let dataReceive = {};
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}

export async function checkSms2FA(username, phone, otp) {
  const url = "/api/auth/validateSms2FA";
  const params = { username, phone, otp };
  let dataReceive = false;
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}

export async function checkPassWord(username, password) {
  const url = "/api/auth/checkPassword";
  const params = {
    username,
    password,
  };
  let dataReceive = false;
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}

export async function checkUsernameAndPassword(username, password) {
  const url = "/api/auth/checkUsernameAndPassword";
  const params = {
    username,
    password,
  };
  let dataReceive = false;
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}

export async function changePassword(username, password) {
  const url = "/api/auth/changePassword";
  const params = {
    username,
    password,
  };
  let dataReceive = false;
  await API.post(url, params)
    .then((response) => {
      dataReceive = response.data;
    })
    .catch((error) => standardResponse(false, error.response?.data));
  return dataReceive;
}

export async function generateQRCode2FA(username, secret) {
  const reponse = await API.get(`/api/auth/generateQR?username=${username}&secret=${secret}`);
  return reponse.data;
}

export async function generateSecret() {
  const reponse = await API.get(`/api/auth/generateSecret`);
  return reponse.data;
}

export async function validateOtpAuthenticator(secret, otp, username) {
  const reponse = await API.post(`/api/auth/validateOtpAuthenticator`, { secret, otp, username });
  if (reponse.data.object.validated) {
    return true;
  }
  return false;
}

export async function update2FAType(username, twoFAType) {
  const reponse = await API.post(`/api/auth/update2FA`, { username, twoFAType });
  return reponse.data;
}

export async function check2FA(username) {
  const reponse = await API.get(`/api/auth/check2FA?username=${username}`);
  return reponse.data;
}

export async function checkTokenValid(token) {
  const reponse = await API.get(`/api/auth/validateToken?token=${token}`);
  return reponse.data;
}

export async function changePasswordCheckOldPwd(username, oldPassword, newPassword) {
  const user = {
    username,
    oldPassword,
    newPassword,
  };
  const reponse = await API.post(`/api/auth/changePasswordCheckOldPwd`, user);
  return reponse.data;
}

export async function updatePattern(username, password) {
  const user = {
    username,
    password,
  };
  const reponse = await API.post(`/api/auth/updatePattern`, user);
  return reponse.data;
}

export async function checkPattern(username, password) {
  const user = {
    username,
    password,
  };
  const reponse = await API.post(`/api/auth/checkPattern`, user);
  return reponse.data;
}
export async function generateCaptcha() {
  const url = "/api/auth/generate-captcha";
  try {
    const response = await APICookie.get(url, { responseType: "arraybuffer" });

    if (response.status === 200) {
      const captchaImage = new Blob([response.data], { type: "image/png" });
      const captchaUrl = URL.createObjectURL(captchaImage);
      return { success: true, captchaUrl };
    }
    return { success: false };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error fetching CAPTCHA:", error);
    const errorMessage = error.response ? error.response.data : error.message;
    return { success: false, error: errorMessage || "An error occurred while fetching CAPTCHA." };
  }
}

export async function verifyCaptcha(inputText) {
  try {
    const response = await APICookie.post("/api/auth/verify-captcha", {
      captchaText: inputText,
    });

    // Trả kết quả luôn, không cần else
    if (response.data?.success) {
      return true;
    }

    return false;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Lỗi xác thực CAPTCHA:", error);
    return false;
  }
}

export async function setupGoogleAuthenticator(username) {
  const secret = await generateSecret();
  const qrCodeUrl = await generateQRCode2FA(username, secret);
  return {
    secret,
    qrCodeUrl,
  };
}

export async function setupMicrosoftAuthenticator(username) {
  const secret = await generateSecret();
  const qrCodeUrl = await generateQRCode2FA(username, secret);

  return {
    secret,
    qrCodeUrl,
  };
}

export async function verifyAndEnable2FA(username, secret, otp, type) {
  const isValid = await validateOtpAuthenticator(secret, otp, username);
  // eslint-disable-next-line no-console
  console.log(isValid);

  if (isValid) {
    await update2FAType(username, type);
    return true;
  }
  return false;
}

export async function verify2FALogin(username, otp) {
  const isValid = await validateOtpAuthenticator("null", otp, username);
  // eslint-disable-next-line no-console
  console.log(isValid);

  return isValid;
}

export async function disable2FA(username) {
  return update2FAType(username, 0);
}
export async function checkUserHas2FA(username) {
  const response = await check2FA(username);
  if (response && response.data && response.data.twofaType) {
    return response.data.twofaType;
  }
  return 0;
}

export async function loginWith2FA(username, password, otpCode = null) {
  const userValid = await checkUsernameAndPassword(username, password);
  if (!userValid) {
    return { success: false, message: "Tên đăng nhập hoặc mật khẩu không chính xác" };
  }
  const twoFAType = await checkUserHas2FA(username);

  if (twoFAType === 0 || twoFAType === null || twoFAType === undefined) {
    const userData = await loginToGetToken(username, password);
    return { success: true, userData, require2FA: false };
  }

  // Nếu có 2FA, kiểm tra xem đã cung cấp OTP chưa
  if (!otpCode) {
    // Nếu chưa cung cấp OTP, yêu cầu người dùng nhập
    return {
      success: false,
      require2FA: true,
      twoFAType,
      message: "Vui lòng nhập mã xác thực từ ứng dụng Authenticator",
    };
  }
  const otpValid = await verify2FALogin(username, otpCode);
  if (otpValid) {
    const userData = await loginToGetToken(username, password);
    return { success: true, userData, require2FA: false };
  }
  return {
    success: false,
    require2FA: true,
    twoFAType,
    message: "Mã xác thực không chính xác hoặc đã hết hạn",
  };
}

export async function verifyUserLoggedIn() {
  try {
    const res = await API.get("/api/auth/verify-token", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      validateStatus: () => true, // ✅ Luôn trả response, không throw
    });

    return res.status === 200 && res.data?.status === 200;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("verifyUserLoggedIn error:", e);
    return false;
  }
}
